export const sections = [
    { value: "top_full", label: "Full Top" },
    // { value: "center_full", label: "Full Center"},
    // { value: "center", label: "Center" },
    // { value: "banner_games", label: "Games" },
    // { value: "banner_roviders", label: "Proveedores" },
];

export const languages = [
    { label: "Español", value: "ES" },
    { label: "Inglés", value: "EN" },
    { label: "Portugués", value: "PT" },
];

export let status = [
    { value: 0, label: "Desactivo" },
    { value: 1, label: "Activo" },
];


